import { BillingPlanTier } from '@core/billing-types';

export const isBillingPlanLegacy = (tier: BillingPlanTier | null): boolean => {
  const legacyTiers = new Set([
    BillingPlanTier.Launch,
    BillingPlanTier.Scale,
    BillingPlanTier.Lead,
  ]);
  return legacyTiers.has(<BillingPlanTier>tier);
};
